<template>
  <div class="filtro-overlay">
    <div class="filtro-modal">
      <button
        type="button"
        class="filtro-modal__close"
        @click="$emit('cerrar')"
      >
        ✕
      </button>

      <div class="filtro-modal__header">
        <h2 class="filtro-modal__title">Filtrar por categoría</h2>
        <p class="filtro-modal__subtitle">
          Selecciona una o varias categorías para filtrar los productos visibles.
        </p>
      </div>

      <!-- Chips de categorías -->
      <div class="filtro-modal__chips">
        <button
          v-for="cat in categorias || []"
          :key="cat.id_categoria"
          type="button"
          class="filtro-chip"
          :class="{
            'filtro-chip--active': categoriasSeleccionadas.includes(cat.id_categoria),
          }"
          @click="toggle(cat.id_categoria)"
        >
          <span class="filtro-chip__label">
            {{ cat.nombre }}
          </span>
        </button>

        <p
          v-if="!categorias || categorias.length === 0"
          class="filtro-modal__empty"
        >
          No hay categorías disponibles.
        </p>
      </div>

      <!-- Acciones -->
      <div class="filtro-modal__footer">
        <button
          type="button"
          class="filtro-footer__btn filtro-footer__btn--ghost"
          @click="limpiar"
        >
          Limpiar
        </button>

        <button
          type="button"
          class="filtro-footer__btn filtro-footer__btn--primary"
          @click="$emit('aplicar', categoriasSeleccionadas)"
        >
          Aplicar filtros
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FiltroCategorias',
  props: {
    categorias: {
      type: Array,
      default: () => [],
    },
    seleccionadas: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      categoriasSeleccionadas: [...this.seleccionadas],
    };
  },
  methods: {
    toggle(id) {
      if (this.categoriasSeleccionadas.includes(id)) {
        this.categoriasSeleccionadas = this.categoriasSeleccionadas.filter(
          (c) => c !== id
        );
      } else {
        this.categoriasSeleccionadas.push(id);
      }
    },
    limpiar() {
      this.categoriasSeleccionadas = [];
    },
  },
};
</script>

<style scoped lang="scss">
.filtro-overlay {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  background: radial-gradient(
      circle at 0 0,
      rgba(148, 163, 184, 0.3),
      rgba(15, 23, 42, 0.98)
    );
  backdrop-filter: blur(18px);
}

/* Modal glass */
.filtro-modal {
  position: relative;
  width: 100%;
  max-width: 640px;
  border-radius: 1.5rem;
  padding: 1.4rem 1.35rem 1.15rem;
  background: radial-gradient(
      circle at 0 0,
      rgba(148, 163, 184, 0.35),
      rgba(15, 23, 42, 0.97)
    );
  border: 1px solid rgba(148, 163, 184, 0.7);
  box-shadow:
    0 22px 60px rgba(15, 23, 42, 0.95),
    0 0 0 1px rgba(15, 23, 42, 0.9);
  color: #e5e7eb;
}

/* Close button */
.filtro-modal__close {
  position: absolute;
  top: 0.55rem;
  right: 0.7rem;
  border: none;
  background: transparent;
  color: #cbd5f5;
  cursor: pointer;
  font-size: 0.9rem;
  padding: 0.2rem;
}

/* Header */
.filtro-modal__header {
  margin-bottom: 0.85rem;
}

.filtro-modal__title {
  font-size: 1rem;
  font-weight: 600;
  color: #f9fafb;
}

.filtro-modal__subtitle {
  margin-top: 0.2rem;
  font-size: 0.8rem;
  color: #94a3b8;
}

/* Chips container */
.filtro-modal__chips {
  margin-top: 0.2rem;
  margin-bottom: 0.85rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.filtro-modal__empty {
  font-size: 0.8rem;
  color: #e5e7eb;
}

/* Chip */
.filtro-chip {
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.75);
  background: rgba(15, 23, 42, 0.92);
  color: #e5e7eb;
  font-size: 0.78rem;
  padding: 0.25rem 0.7rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  transition:
    background 0.16s ease,
    border-color 0.16s ease,
    box-shadow 0.18s ease,
    transform 0.08s ease;
}

.filtro-chip__label {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.filtro-chip--active {
  background: radial-gradient(
      circle at 0 0,
      rgba(59, 130, 246, 0.45),
      rgba(15, 23, 42, 0.98)
    );
  border-color: rgba(59, 130, 246, 0.95);
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.9);
}

.filtro-chip:hover {
  background: rgba(15, 23, 42, 1);
  border-color: rgba(148, 163, 184, 0.95);
}

/* Footer */
.filtro-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.45rem;
  margin-top: 0.35rem;
}

.filtro-footer__btn {
  border-radius: 999px;
  font-size: 0.8rem;
  padding: 0.35rem 0.9rem;
  cursor: pointer;
  border: 1px solid transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 90px;
  transition:
    background 0.16s ease,
    border-color 0.16s ease,
    box-shadow 0.18s ease,
    transform 0.08s ease;
}

.filtro-footer__btn--ghost {
  background: rgba(15, 23, 42, 0.9);
  border-color: rgba(148, 163, 184, 0.7);
  color: #e5e7eb;
}

.filtro-footer__btn--ghost:hover {
  background: rgba(15, 23, 42, 1);
  border-color: rgba(148, 163, 184, 0.95);
}

.filtro-footer__btn--primary {
  background: #e5e7eb;
  color: #020617;
  border-color: transparent;
}

.filtro-footer__btn--primary:hover {
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.9);
}

/* Responsive */
@media (max-width: 640px) {
  .filtro-modal {
    padding: 1.1rem 1rem 1rem;
    border-radius: 1.25rem;
  }

  .filtro-modal__footer {
    flex-direction: row;
    justify-content: flex-end;
  }
}
</style>
